import { createSlice } from '@reduxjs/toolkit';
import {
  clearStoredAuth,
  createSafeAuthData,
  getStoredAuth,
  persistAuth,
} from '../utils/auth';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  isLogin: false,
  token: null
};

const storedAuth = getStoredAuth();
const userData = storedAuth.user;

if (userData && storedAuth.token) {
  initialState.user = userData;
  initialState.response = userData;
  initialState.token = storedAuth.token;
  initialState.isLogin = true;
} else {
  initialState.response = null;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup: (state) => {
      state.loading = true;
      state.callTimes++;
    },
    signin: (state) => {
      state.loading = true;
      state.callTimes++;
    },
    failed: (state, { payload }) => {
      console.log(payload);
      state.error = true;
      state.loading = false;
      state.message = payload?.message || payload?.data?.message || 'Something went wrong';
      state.response = null;
    },
    getoneuser: (state) => {
      state.callTimes++;
    },
    successLogin: (state, { payload }) => {
      const safeData = createSafeAuthData(payload?.data);
      const remember = Boolean(payload?.remember);

      persistAuth(safeData, remember);

      state.loading = false;
      state.user = safeData;
      state.response = safeData;
      state.message = payload?.message || 'Login Successful';
      state.token = safeData.access_token || null;
      state.error = null;
      state.isLogin = Boolean(safeData.access_token);
    },
    success: (state, { payload }) => {
      const safeData = createSafeAuthData(payload?.data);
      const hasToken = Boolean(safeData.access_token);

      state.loading = false;
      state.user = hasToken ? safeData : state.user;
      state.response = safeData;
      state.message = payload?.message || 'Success';
      state.token = hasToken ? safeData.access_token : state.token;
      state.error = null;
      state.isLogin = hasToken ? true : state.isLogin;
    },
    logout: (state) => {
      clearStoredAuth();
      state.user = null;
      state.response = null;
      state.loading = false;
      state.message = 'Logout Successfully';
      state.isLogin = false;
      state.token = null;
    },
    otpverification: (state) => {
      state.loading = true;
    },
    opdotpverification: (state, { payload }) => {
      console.log('payload', payload);
      state.loading = true;
    },
    clear: (state) => {
      clearStoredAuth();
      state.user = null;
      state.response = null;
      state.loading = false;
      state.message = '';
      state.isLogin = false;
      state.token = null;
    },
  },
});

export const {
  signup,
  signin,
  success,
  failed,
  logout,
  otpverification,
  successLogin,
  getoneuser,
  clear,
  opdotpverification,
} = userSlice.actions;

export default userSlice.reducer;
